.outer {
  position: relative;
}

.copy {
  position: absolute;
  right: 1em;
  bottom: 1em;
  display: none;
}

.outer[data-show-copy]:hover .copy {
  display: block;
}

.outer:not([data-show-emphasis]) mark {
  background-color: transparent;
}
